// Generated with util/create-component.js
import React, { useRef, useEffect, useState } from 'react'
import { ButtonProps } from './Button.types'
import merge from 'lodash/merge'
import Icon from '../Icon/Icon'
import Tooltip from '../Tooltip/Tooltip'
import { useCombinedRefs } from '../../helpers/helpers'

// @ts-ignore
import { useHistory } from 'react-router-dom'

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
    const {
        className = '',
        isLoading = false,
        isDisabled = false,
        isDiscreet = false,
        isMinimal = false,
        isFullWidth = false,
        icon,
        iconProps = {},
        iconPosition = 'left',
        label = '',
        type = 'default',
        size = 'md',
        style = {},
        buttonStyle = {},
        link = null,
        noPadding = false,
        noMargin = false,
        noRadiusTopRight = false,
        noRadiusTopLeft = false,
        noRadiusBottomRight = false,
        noRadiusBottomLeft = false,
        loadingText,
        onClick,
        onMouseDown = (e) => {},
        onMouseUp = (e) => {},
        onMouseEnter = (e) => {},
        onMouseLeave = (e) => {},
        tooltip,
        disabledTooltip,
    } = props
    // const nav = useNavigate()
    let history = useHistory()
    const [width, setWidth] = useState(null)
    const [height, setHeight] = useState(null)
    const [isMouseOver, setIsMouseOver] = useState(false)
    const buttonRef = useRef<HTMLButtonElement>(null)
    const combinedRef = useCombinedRefs(ref, buttonRef)
    const [isClicking, setIsClicking] = useState(false)

    useEffect(() => {
        if (buttonRef.current) {
            const node = buttonRef.current
            const bounding = node.getBoundingClientRect()

            setWidth(bounding.width)
            setHeight(bounding.height)
        }
    }, [])

    const classNames = () => {
        const c = ['r-button-wrapper', className, size]

        if (isDisabled) {
            c.push('r-state-disabled')
        }

        if (isDiscreet) {
            c.push('r-discreet')
        }
        if (isMinimal) {
            c.push('r-minimal')
        }
        if (isLoading) {
            c.push('r-loading')
        }

        if (isClicking) {
            c.push('r-state-clicking')
        }
        if (isFullWidth) {
            c.push('r-size-full-width')
        }

        switch (type) {
            case 'success':
                c.push('r-color-success')
                break
            case 'primary':
                c.push('r-color-primary')
                break
            case 'danger':
                c.push('r-color-danger')
                break
            case 'warning':
                c.push('r-color-warning')
                break
            case 'default':
                c.push('r-color-default')
                break
            default:
                c.push('r-color-default')
        }

        return c.join(' ')
    }

    const _style = {
        padding: noPadding ? 0 : null,
        margin: noMargin ? 0 : null,
    }

    const _buttonStyle = {
        borderBottomLeftRadius: noRadiusBottomLeft ? 0 : null,
        borderBottomRightRadius: noRadiusBottomRight ? 0 : null,
        borderTopLeftRadius: noRadiusTopLeft ? 0 : null,
        borderTopRightRadius: noRadiusTopRight ? 0 : null,
    }

    const handleClick = (e: any) => {
        e.preventDefault()

        if (isDisabled) {
            return
        }

        setIsClicking(true)
        setTimeout(() => {
            setIsClicking(false)
        }, 100)

        if (link) {
            // nav(link)
            history.push(link)
        } else if (onClick) {
            onClick(e)
        }
    }

    const iconStyle = {
        marginRight: label ? '5px' : null,
    }

    const iconRightStyle = {
        marginLeft: label ? '5px' : null,
    }

    return (
        <div style={merge(_style, style)} className={classNames()}>
            <button
                data-testid='Button'
                style={merge(_buttonStyle, buttonStyle)}
                ref={combinedRef}
                className='r-button'
                onClick={handleClick}
                onMouseUp={onMouseUp}
                onMouseDown={onMouseDown}
                onMouseEnter={(e) => {
                    onMouseEnter(e)
                    setIsMouseOver(true)
                }}
                onMouseLeave={(e) => {
                    onMouseLeave(e)
                    setIsMouseOver(false)
                }}
            >
                {icon && iconPosition === 'left' ? (
                    <Icon {...iconProps} type={icon} size={size} style={iconStyle} />
                ) : null}
                {isLoading && loadingText ? loadingText : label}
                {icon && iconPosition === 'right' ? (
                    <Icon {...iconProps} type={icon} size={size} style={iconRightStyle} />
                ) : null}
            </button>

            {tooltip && !disabledTooltip ? (
                <Tooltip show={isMouseOver} anchor={buttonRef}>
                    {tooltip}
                </Tooltip>
            ) : (
                ''
            )}
            {disabledTooltip && isDisabled ? (
                <Tooltip show={isMouseOver} anchor={buttonRef}>
                    {disabledTooltip}
                </Tooltip>
            ) : (
                ''
            )}
            {/* {isLoading ? <div>/!* <img src={loadingHorizontal} width={20} /> *!/</div> : ''} */}
        </div>
    )
})

export default Button
